export default __webpack_public_path__ + "static/media/Sintony-Bold.74adb8f3.eot";